import {
  BusinessRelationshipGoalsType,
  BusinessRelationshipInvestmentGoalType,
} from 'api/types/entity';
import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import {
  useFormContext,
  Field,
} from 'modules/client/client/forms/businessRelationshipForm';

export interface FormContentProps {}

export const FormContent = () => {
  const { values } = useFormContext();
  const { t } = useTranslation();

  const isOtherBusinessRelationshipGoal =
    values.businessRelationship.businessRelationshipGoals?.find(
      (v) => v?.value === BusinessRelationshipGoalsType.Other
    ) !== undefined;

  const isOtherInvestmentGoal =
    values.businessRelationship.investmentGoals?.find(
      (v) => v?.value === BusinessRelationshipInvestmentGoalType.Other
    ) !== undefined;

  return (
    <GridFields>
      <Field.Autocomplete
        fullWidth
        multiple
        showRequiredMark
        label={t(
          'client.client.businessRelationship.businessRelationshipGoals.label'
        )}
        name="businessRelationship.businessRelationshipGoals"
        optionLabelKey="label"
        options={Object.values(BusinessRelationshipGoalsType).map((v) => ({
          label: t(
            `client.client.businessRelationship.businessRelationshipGoals.types.${v}`
          ),
          value: v,
        }))}
        optionValueKey="value"
        placeholder={t(
          'client.client.businessRelationship.businessRelationshipGoals.placeholder'
        )}
        variant="select"
      />

      {isOtherBusinessRelationshipGoal && (
        <Field.Text
          showRequiredMark
          label={t(
            'client.client.businessRelationship.otherBusinessRelationshipGoal.label'
          )}
          name="businessRelationship.otherBusinessRelationshipGoal"
          placeholder={t(
            'client.client.businessRelationship.otherBusinessRelationshipGoal.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        multiple
        showRequiredMark
        label={t('client.client.businessRelationship.investmentGoals.label')}
        name="businessRelationship.investmentGoals"
        optionLabelKey="label"
        options={Object.values(BusinessRelationshipInvestmentGoalType).map(
          (v) => ({
            label: t(
              `client.client.businessRelationship.investmentGoals.types.${v}`
            ),
            value: v,
          })
        )}
        optionValueKey="value"
        placeholder={t(
          'client.client.businessRelationship.investmentGoals.placeholder'
        )}
        variant="select"
      />

      {isOtherInvestmentGoal && (
        <Field.Text
          showRequiredMark
          label={t(
            'client.client.businessRelationship.otherInvestmentGoal.label'
          )}
          name="businessRelationship.otherInvestmentGoal"
          placeholder={t(
            'client.client.businessRelationship.otherInvestmentGoal.placeholder'
          )}
        />
      )}
    </GridFields>
  );
};
